module.exports = __webpack_public_path__ + "static/media/screenshot-job-listing.af46802c.png";